module.exports = __webpack_public_path__ + "static/media/cryptocoins.284a85fe.ttf";